import React, { useEffect, useRef } from 'react';
import './IntroAnimation.css';

const IntroAnimation = ({ onComplete }) => {
  const canvasRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    // Click Spark Setup
    const sparkCanvas = canvasRef.current;
    const ctxSpark = sparkCanvas.getContext('2d');
    let sparks = [];
    const sparkColor = '#BBB0AC';
    const sparkSize = 10;
    const sparkRadius = 40;
    const sparkCount = 16;
    const duration = 800;

    sparkCanvas.width = window.innerWidth;
    sparkCanvas.height = window.innerHeight;

    function easeOutQuad(t) { return t * (2 - t); }

    function triggerSpark(x, y) {
      const now = performance.now();
      for (let i = 0; i < sparkCount; i++) {
        sparks.push({
          x, y,
          angle: (2 * Math.PI * i) / sparkCount,
          startTime: now
        });
      }
    }

    function drawSparks(timestamp) {
      ctxSpark.clearRect(0, 0, sparkCanvas.width, sparkCanvas.height);
      sparks = sparks.filter(spark => {
        const elapsed = timestamp - spark.startTime;
        if (elapsed >= duration) return false;
        const progress = elapsed / duration;
        const eased = easeOutQuad(progress);

        const distance = eased * sparkRadius;
        const lineLength = sparkSize * (1 - eased);

        const x1 = spark.x + distance * Math.cos(spark.angle);
        const y1 = spark.y + distance * Math.sin(spark.angle);
        const x2 = spark.x + (distance + lineLength) * Math.cos(spark.angle);
        const y2 = spark.y + (distance + lineLength) * Math.sin(spark.angle);

        ctxSpark.strokeStyle = sparkColor;
        ctxSpark.lineWidth = 2;
        ctxSpark.beginPath();
        ctxSpark.moveTo(x1, y1);
        ctxSpark.lineTo(x2, y2);
        ctxSpark.stroke();
        return true;
      });
      requestAnimationFrame(drawSparks);
    }
    requestAnimationFrame(drawSparks);

    // Sequence Animation
    const fullText = "i need web developers who do modern animations, scroll stories, experience management, are young, smart, hardworking, low price but quality work...";

    async function runSequence() {
      const wait = ms => new Promise(r => setTimeout(r, ms));
      
      await wait(500);
      
      const cursor = document.getElementById('anim-cursor');
      const typedEl = document.getElementById('anim-typed');
      const blinkEl = document.getElementById('anim-blink');
      const searchBtn = document.getElementById('anim-search-btn');
      const text1 = document.getElementById('anim-text1');
      const text2 = document.getElementById('anim-text2');
      const container = containerRef.current;

      cursor.style.opacity = '1';
      blinkEl.style.opacity = '1';
      
      let currentText = '';
      for (let i = 0; i < fullText.length; i++) {
        currentText += fullText[i];
        typedEl.textContent = currentText;
        await wait(25);
      }

      await wait(500);

      blinkEl.style.animation = 'none';
      const btnRect = searchBtn.getBoundingClientRect();
      const targetLeft = btnRect.left + btnRect.width / 2;
      const targetTop = btnRect.top + btnRect.height / 2;

      cursor.style.left = targetLeft + 'px';
      cursor.style.top = targetTop + 'px';

      await wait(1000);

      searchBtn.style.transform = "scale(0.85)";
      triggerSpark(targetLeft, targetTop);
      setTimeout(() => { searchBtn.style.transform = "scale(1)"; }, 150);

      cursor.style.opacity = '0';
      await wait(600);

      document.body.classList.add('state-shrinking');
      await wait(1000);

      text1.classList.add('show');
      await wait(2000);

      text1.classList.remove('show');
      text1.classList.add('hide');
      text2.classList.add('show');
      
      await wait(2000);
      
      // Premium smooth reveal - slide up with elegant fade
      container.style.transition = 'all 1.2s cubic-bezier(0.76, 0, 0.24, 1)';
      container.style.transform = 'translateY(-100vh) scale(0.95)';
      container.style.opacity = '0';
      await wait(1200);
      
      onComplete();
    }

    runSequence();
  }, [onComplete]);

  return (
    <div ref={containerRef} className="intro-animation-full">
      <div className="fixed-bg-black"></div>

      <canvas ref={canvasRef} className="click-spark-container"></canvas>

      <div className="intro-overlay">
        <div id="anim-search-box" className="search-box-mockup">
          <span id="anim-typed" className="typed-text"></span>
          <span id="anim-blink" className="cursor-blink">|</span>
          <div id="anim-search-btn" className="search-icon-wrapper">
            <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
          </div>
        </div>

        <div className="intermediate-text-wrapper">
          <div id="anim-text1" className="intermediate-text">finding best results...</div>
          <div id="anim-text2" className="intermediate-text">these meet your requirements</div>
        </div>
      </div>

      <div id="anim-cursor" className="custom-cursor">
        <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z"></path>
          <path d="M13 13l6 6"></path>
        </svg>
      </div>
    </div>
  );
};

export default IntroAnimation;